import React from "react";
import EpaInformation from "../parts/Dossier/EpaInformation";
import EpaDossier from "../parts/Dossier/EpaDossier";
import {EpaComments} from "../parts/Dossier/EpaComments";
import Header from "../parts/Header/Header";
import Footer from "../parts/Footer/Footer";

const Dossier = ({match}) => {

    return (
        <>
            <Header/>
            <main className="main">
                <EpaInformation epaId={match.params.epaId}/>
                <EpaDossier epaId={match.params.epaId}/>
                <EpaComments/>
            </main>

            <Footer/>
        </>
    )
};

export default Dossier
